// src/pages/HeroSection.jsx
import React, { useState, useEffect } from "react";

const HeroSection = () => {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const fetchHeroData = async () => {
      const backendURL = process.env.REACT_APP_BACKEND_URL;
      try {
        // Replace with your actual Firebase function URL (or your own endpoint)
        const response = await fetch(`${backendURL}details/hero`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        // Build slides array from the fetched hero document.
        // Adjust keys if your document uses different field names.
        const heroSlides = [
          {
            id: 1,
            image: data.heroImage1,
            title: data.heroHeader1,
            description: data.heroDescription1 || "",
            ctaText: data.heroCTA1 || "Learn More",
          },
          {
            id: 2,
            image: data.heroImage2,
            title: data.heroHeader2,
            description: data.heroDescription2 || "",
            ctaText: data.heroCTA2 || "Discover",
          },
          {
            id: 3,
            image: data.heroImage3,
            title: data.heroHeader3,
            description: data.heroDescription3 || "",
            ctaText: data.heroCTA3 || "Shop Now",
          },
        ];
        setSlides(heroSlides);
      } catch (error) {
        console.error("Error fetching hero data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHeroData();
  }, []);

  useEffect(() => {
    if (slides.length > 0) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 5000); // Auto-rotate every 5 seconds
      return () => clearInterval(interval);
    }
  }, [slides]);

  if (loading) {
    return (
      <section className="bg-white antialiased flex justify-center items-center h-[640px]">
        {/* Tailwind spinner */}
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-yellow-900"></div>
      </section>
    );
  }

  return (
    <section className="bg-white antialiased">
      <div className="mx-auto max-w-screen-2xl">
        <div className="relative h-[640px] w-full overflow-hidden">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`absolute h-full w-full transition-transform duration-1000 ease-in-out ${
                index === currentSlide ? "translate-x-0" : "translate-x-full"
              }`}
            >
              <div
                className="absolute left-1/2 top-1/2 block h-full w-full -translate-x-1/2 -translate-y-1/2 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                {/* Dark overlay to dim bright images */}
                <div className="absolute inset-0 bg-black bg-opacity-40"></div>
                <div className="absolute top-1/2 z-10 w-full px-4 sm:left-1/2 sm:-translate-x-1/2 max-w-full lg:px-0">
                  <h2 className="text-center mb-3 text-3xl font-extrabold leading-none text-white lg:text-5xl">
                    {slide.title}
                  </h2>
                  <p className="mb-5 text-center text-gray-200">{slide.description}</p>
                  {/* Uncomment and adjust the CTA button as needed:
                  <a
                    href="#"
                    className="inline-flex rounded-lg bg-primary-700 px-5 py-3 text-base font-medium text-white hover:bg-primary-800 focus:outline-none focus:ring-4 focus:ring-primary-300"
                  >
                    {slide.ctaText}
                  </a> */}
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* (Optional) Slide indicators can go here */}
      </div>
    </section>
  );
};

export default HeroSection;
